import React, { Fragment } from "react";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from '../../components/Help-Desk-Components/Footer/Footer';
import { NavLink } from "react-router-dom";
import "./steps.css";
import HeaderBuga from "../../components/header6/Header6";

const LivenessCheck = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <HeaderBuga />
        <section
          className="page-title pt-100 md:pt-30 pos-rel bg_img breadcrums-bgr"
          // style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap ">
             <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section  pt-20 pb-130">
          <div className="container" bis_skin_checked={1}>
            <div className="row clearfix" bis_skin_checked={1}>
              <div
                className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
                bis_skin_checked={1}
              >
                <div className=" px-0 pb-0 mb-3" bis_skin_checked={1}>
                  <h2 className="mb-3" id="heading">
                    KYC Documents Upload
                  </h2>
                  <div className="row justify-content-center">
                    <div className="col-md-10 text-center">
                      <p className="mb-3 fs-5">
                        On our mobile app to complete your onboarding process we
                        require your Photo ID and a selfie. We use ID Scan
                        solution which takes less than a minute to complete this
                        for you.{" "}
                      </p>
                    </div>
                  </div>

                  {/*<div class="row justify-content-center">
                          <div class="col-4">

                              <button type="button" class="btn btn-primary video-btn2" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/qceO0YPfcVo" data-bs-target="#myModal">
                                  <i class="fa fa-play"></i> Watch Explainer Video
                              </button>
                          </div>
                      </div>*/}
                  <div id="msform" bis_skin_checked={1}>
                    {/* progressbar */}
                    <ul id="progressbar">
                      <NavLink to="/kycupload" bis_skin_checked={1}>
                        <li className="active" id="confirm">
                          <strong>1) Scanning Your Id</strong>
                        </li>
                      </NavLink>
                      <NavLink to="/livenesscheck" bis_skin_checked={1}>
                        <li id="confirm" className="active">
                          <strong>2) Liveness Check</strong>
                        </li>
                      </NavLink>
                      <NavLink to="/finishcheck" bis_skin_checked={1}>
                        <li id="confirm">
                          <strong>Finish</strong>
                        </li>
                      </NavLink>
                    </ul>
                    {/* fieldsets */}
                    <fieldset>
                      <div className="form-card" bis_skin_checked={1}>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <h4 className="mb-4">Taking Perfect Photo</h4>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto1.png"
                                alt="Taking Perfect Photo"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Make sure the camera has a consistent aspect
                                  ratio, so it does not stretch the image in any
                                  direction.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr className="hrcss" />
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <h4 className="mb-4 mt-2">What to avoid?</h4>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto7.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text mb-4">
                                  Avoid shadows on the face or a strong side
                                  light.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto3.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text mb-1">
                                  Make sure your face is within the circle
                                  guidelines shown on the screen.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto4.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Make sure you are in a well-lit room that is
                                  not too dark.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto2.png"
                                alt="What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Turn off any filters that might distort the
                                  image but keep the white light correction ON.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto6.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Avoid having a light source behind the
                                  person's head, such as from a window.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto8.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Avoid anything covering the face, such as
                                  masks, hats, sunglasses or hair flopping over
                                  the face.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src=" /photo/takephoto5.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  For active liveness only - When performing
                                  actions such as turn right, do not over-rotate
                                  the face to 90 degrees, an angle of 35 degrees
                                  should be enough. Start with the camera raised
                                  so there is space to look down.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <NavLink
                        to="/kycupload"
                        type="button"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="mt-5 sofax-default-btn pill sofax-header-btn text-whitee"
                        style={{
                          background: "#ffc107",
                          color: "black",
                          fontWeight: "bold",
                          height: "40px",
                          width: "200px",
                          fontSize: "24px",
                          padding: "4px",
                          borderRadius: "20px",
                        }}
                        bis_skin_checked={1}
                      >
                        Previous
                      </NavLink>
                      <NavLink
                        to="/finishcheck"
                        type="button"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="mt-5 ms-2 sofax-default-btn pill sofax-header-btn text-whitee"
                        style={{
                           background: "#ffc107",
                          color: "black",
                          fontWeight: "bold",
                          height: "40px",
                          width: "200px",
                          fontSize: "24px",
                          padding: "4px",
                          borderRadius: "20px",
                          

                        }}
                        bis_skin_checked={1}
                      >
                        Next
                      </NavLink>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
   
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default LivenessCheck;
